import { Autocomplete, Box, Button, FormControlLabel, Input, Radio, RadioGroup, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LocationList } from './services/settingApi';
import { useNavigate, useParams } from 'react-router-dom';
import { SETTING_CONFIG } from './config.';
import api from '../../api/api'
import Swal from 'sweetalert2';
import RequireField from '../../component/RequireField';
import dayjs from 'dayjs';
import useDebounce from '../../hook/useDebounce';

export default function ViewBranchs() {
    const navigate = useNavigate();

    const { id } = useParams()
    const [tel, setTel] = useState('')
    const [fax, setFax] = useState('')
    const [BranchNo, setBranchNo] = useState('')
    const [BranchName, setBranchName] = useState('')
    const [InitialsName, setInitialsName] = useState('')
    const [email, setEmail] = useState('')
    const [address, setAddress] = useState('')
    const [province, setProvince] = useState('')
    const [value, setValue] = useState({
        ProvinceName: '',
        DistrictName: '',
        SubDistrictName: '',
        Zipcode: ''
    })
    const [district, setDistrict] = useState('')
    const [subDistrict, setSubDistrict] = useState('')
    const [zipcode, setZipcode] = useState('')
    const debouncedSearchP = useDebounce(province, 500)
    const debouncedSearchD = useDebounce(district, 500)
    const debouncedSearchSD = useDebounce(subDistrict, 500)
    const debouncedSearchZ = useDebounce(zipcode, 500)

    
    const [locations, setLocations] = useState([])
    const [Latitude, setLatitude] = useState('')
    const [Longitude, setLongitude] = useState('')
    const [detail, setDetail] = useState()
    const [Status, setStatus] = useState('Y')
    const [BranchNameError, setBranchNameError] = useState(false)
    const [validBranchNo, setValidBranchNo] = useState(false)
    const [validBranchNoText, setValidBranchNoText] = useState('')


    const getBranchInfo = async () => {

        const url = SETTING_CONFIG.requests.getBranchs.url + `/${id}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setDetail(data.result)
            setBranchName(data.result.BranchName)
            setBranchNo(data.result.BranchNo)
            setInitialsName(data.result.InitialsName)
            setAddress(data.result.Address)
            setLatitude(data.result.Latitude)
            setLongitude(data.result.Longitude)
            setTel(data.result.Tel)
            setEmail(data.result.Email)
            setFax(data.result.Fax)
            setValue({
                ProvinceName: data.result?.Province,
                DistrictName: data.result?.District,
                SubDistrictName: data.result?.SubDistrict,
                Zipcode: data.result?.Zipcode
            })
            setStatus(data.result.Status)
        }
    }

    const branchAdd = async () => {
        const body = {
            BranchId: detail ? detail.BranchId : null,
            BranchNo: BranchNo,
            BranchName: BranchName,
            InitialsName: InitialsName,
            Address: address,
            Province: province,
            District: district,
            SubDistrict: subDistrict,
            Zipcode: zipcode,
            Tel: tel,
            Fax: fax,
            Status: Status,
            Email: email,
            Latitude: Latitude,
            Longitude: Longitude
        }
        if (body?.BranchId) {
            const url = SETTING_CONFIG.requests.getBranchs.url + `/${body?.BranchNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                getBranchInfo()
                Swal.fire(
                    'ทำรายการสำเร็จ',
                    '',
                    'success'
                )
            }else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }
        } else {

            const res = await api.post(SETTING_CONFIG.requests.getBranchs.url, body)
            const data = res.data
            if (data.status === true) {
                navigate('/setting/branchs/'+ data.result.BranchNo)

                Swal.fire(
                    'ทำรายการสำเร็จ',
                    '',
                    'success'
                )
            }else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }
        }
    }
    const handleSubmit = () => {
        if (!BranchNo) {
            setValidBranchNo(true)
            setValidBranchNoText('กรุณากรอกรหัสศูนย์')
        }
        if (!BranchName) {
            setBranchNameError(true)
        }
        if (BranchNo && BranchName) {
            branchAdd()
        }

    }

    useEffect(() => {
        if (id) {
            getBranchInfo()
        }
    }, [])

    useEffect(() => {
        if (debouncedSearchP.length >= 0) {
            const body = {
                typeSearch: 'P',
                Text: debouncedSearchP
            };
            LocationList(body, setLocations)
        }
        if (debouncedSearchD.length >= 0) {
            const body = {
                typeSearch: 'D',
                Text: debouncedSearchD
            };
            LocationList(body, setLocations)
        }
        if (debouncedSearchSD.length >= 0) {
            const body = {
                typeSearch: 'SD',
                Text: debouncedSearchSD
            };
            LocationList(body, setLocations)
        }
        if (debouncedSearchZ.length >= 0) {
            const body = {
                typeSearch: 'Z',
                Text: debouncedSearchZ
            };
            LocationList(body, setLocations)
        }
    }, [debouncedSearchP, debouncedSearchD, debouncedSearchSD, debouncedSearchZ])


    async function validateBranchNo(BranchNo) {
        if (!BranchNo) {
            setValidBranchNo(true)
            setValidBranchNoText('กรุณากรอกรหัสศูนย์')
        }
        if (BranchNo.length === 1) {
            setValidBranchNo(true)
            setValidBranchNoText('กรุณากรอกรหัสให้ครบ 2 หลัก')
        }
        if (BranchNo.length === 2) {
            const url = SETTING_CONFIG.requests.getBranchs.url + `/${BranchNo}`;
            const res = await api.get(url)
            const checkStatus = res.data.result
            if (detail && (BranchNo === detail?.BranchNo)) {
                setValidBranchNo(false)
            } else {
                setValidBranchNo(true)
                setValidBranchNoText(checkStatus ? 'มีรหัสสาขานี้อยู่ในระบบแล้ว' : 'สามารถใช้รหัสนี้ได้')
            }
        }
    }
    // useEffect(() => {
    //     validateBranchNo(BranchNo)
    // }, [BranchNo])
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid" >

                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-12 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                ข้อมูลศูนย์เมล็ดพันธุ์ข้าว
                            </label>


                        </div>
                    </div>

                    <div class="row">
                        <div class="row">
                            <div class="col-lg-4 col-sm-12 " style={{ marginBottom: '10px' }}>
                                <label class="labelInput">รหัสศูนย์</label>
                                <Box className={`backgroundField ${validBranchNoText && validBranchNoText !== 'สามารถใช้รหัสนี้ได้' ? 'error' : ''}`}>
                                    <TextField value={BranchNo} onBlur={e => validateBranchNo(e.target.value)
                                    } onChange={e => setBranchNo(e.target.value)} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        disabled={id ? true : false}
                                        inputProps={{ maxLength: 2 }}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                </Box>
                                {validBranchNo && <span style={{ color: validBranchNoText === 'สามารถใช้รหัสนี้ได้' ? 'green' : 'red', fontSize: '12px', }}>{validBranchNoText}</span>}

                            </div>
                            <div class="col-lg-4 col-sm-6 " style={{ marginBottom: '10px' }}>
                                <label class="labelInput">ชื่อศูนย์</label>

                                <RequireField value={BranchName} onChange={setBranchName} type={'text'} error={BranchNameError} setError={setBranchNameError} textError={'กรุณากรอกชื่อศูนย์'} />

                            </div>

                        </div>
                        <div class="row">

                            <div class="col-lg-4 col-sm-12 ">
                                <label class="labelInput">ชื่อย่อ</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={InitialsName} onChange={e => setInitialsName(e.target.value)} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-sm-6">
                                <label class="labelInput">เบอร์โทรศัพท์</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={tel} onChange={e => setTel(e.target.value)} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>



                        </div>

                    </div>

                    <div class="row">
                        <div class="col-lg-4 col-sm-6">
                            <label class="labelInput">แฟกซ์</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={fax} onChange={e => setFax(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <label class="labelInput">อีเมล์</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={email} onChange={e => setEmail(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-12">
                            <label class="labelInput">ตำบล</label>
                            <Autocomplete
                                fullWidth
                                options={locations || []}
                                getOptionLabel={(option) => option?.SubDistrictName}
                                renderOption={(props, option) => (
                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                    </Box>
                                )}
                                loading={locations.length > 0}
                                inputValue={subDistrict || ''}
                                onInputChange={(event, newInputValue) => {
                                    setSubDistrict(newInputValue);
                                }}
                                value={value || ''}
                                onChange={(event, newValue) => {
                                    setValue(newValue)
                                    // setValueD(newValue)
                                }}

                                renderInput={(params) => (
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                        <Input type="text" {...params.inputProps} disableUnderline />

                                    </Box>
                                )} />

                        </div>

                        <div class="col-lg-4 col-md-12">
                            <label class="labelInput">อำเภอ</label>
                            <Autocomplete
                                fullWidth
                                options={locations || []}
                                getOptionLabel={(option) => option?.DistrictName}
                                renderOption={(props, option) => (
                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                    </Box>
                                )}
                                loading={locations.length > 0}
                                inputValue={district || ''}
                                onInputChange={(event, newInputValue) => {
                                    setDistrict(newInputValue);
                                }}
                                value={value || ''}
                                onChange={(event, newValue) => {
                                    setValue(newValue)
                                    // setValueD(newValue)
                                }}

                                renderInput={(params) => (
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                        <Input type="text" {...params.inputProps} disableUnderline />

                                    </Box>
                                )}
                            />
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-12">
                            <label class="labelInput">จังหวัด</label>
                            <Autocomplete
                                fullWidth
                                options={locations || []}
                                getOptionLabel={(option) => option?.ProvinceName}
                                renderOption={(props, option) => (
                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                    </Box>
                                )}
                                loading={locations.length > 0}
                                inputValue={province || ''}
                                onInputChange={(event, newInputValue) => {
                                    setProvince(newInputValue);
                                }}
                                value={value || ''}
                                onChange={(event, newValue) => {
                                    setValue(newValue)
                                    // setValueD(newValue)
                                }}

                                renderInput={(params) => (
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                        <Input type="text" {...params.inputProps} disableUnderline />

                                    </Box>
                                )} />
                        </div>
                        <div class="col-lg-4 col-md-12">
                            <label class="labelInput">รหัสไปรษณีย์</label>
                            <Autocomplete
                                fullWidth
                                options={locations || []}
                                getOptionLabel={(option) => option?.Zipcode}
                                renderOption={(props, option) => (
                                    <Box component="li" {...props} key={option.SubDistrictId}>
                                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.{option?.SubDistrictName} / {option?.Zipcode}
                                    </Box>
                                )}
                                loading={locations.length > 0}
                                inputValue={zipcode || ''}
                                onInputChange={(event, newInputValue) => {
                                    setZipcode(newInputValue);
                                }}
                                value={value || ''}
                                onChange={(event, newValue) => {
                                    setValue(newValue)
                                    // setValueD(newValue)
                                }}

                                renderInput={(params) => (
                                    <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                        <Input type="text" {...params.inputProps} disableUnderline />

                                    </Box>
                                )}
                            />
                        </div>


                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-sm-6">
                            <label class="labelInput">ละติจูดของศูนย์เมล็ดพันธุ์</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={Latitude} onChange={e => setLatitude(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <label class="labelInput">ลองจิจูดของศูนย์เมล็ดพันธุ์</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField value={Longitude} onChange={e => setLongitude(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>


                    </div>
                    {id &&
                        <div class="row" >
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField  disabled value={detail?.CreateId} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField disabled value={detail?.ModifiedId} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>
                    }
                    <div class="row">
                        <div class="col-lg-8 col-sm-12">
                            <label class="labelInput">ที่อยู่</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px', borderRadius:"25px" }}>
                                <TextField value={address} onChange={e => setAddress(e.target.value)} variant="standard" fullWidth multiline rows={3}
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>

                        <div class="col-12 mt-1  text-left ">
                            <RadioGroup
                                row value={Status} onChange={e => setStatus(e.target.value)}
                            >
                                <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                                <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                            </RadioGroup>
                        </div>
                    </div>

                    <hr class="chr" />
                    <div class="row ">

                        <div class="col-12 text-left">
                            <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                            <Button onClick={() => handleSubmit()} variant='contained' sx={{ width: '130px', fontSize: '14px' }}>{id ? 'เเก้ไข' : 'บันทึก'}</Button>
                        </div>
                    </div>
                </div>

            </Page>
        </div>
    )
}
